// import _ from 'lodash/core';
import { Listeners, onSortGoTo, loadScript } from './utils';

(function() {
  'use strict';

  if (!window.backinstockSettings) return;
  
  loadScript('https://a.klaviyo.com/media/js/onsite/onsite.js', () => {
    const klaviyo = window.klaviyo || {};

    klaviyo.init({
      account: window.backinstockSettings.klaviyo_public_api_key || "TmXUED",
      platform: "shopify"
    });
    klaviyo.enable("backinstock", window.backinstockSettings);
  }, 
  () => {
    throw new Error("Klaviyo backinstock script failed to load");
  });
})();

// (async function() {
//   'use strict';
//   // const pluralize = (count, noun, suffix = 's') =>
//   // `${count} ${noun}${count !== 1 ? suffix : ''}`;
//   const theme = window.theme || {};
//   // const { default: $ } = await import(window.modules.jquery);  

//   /**
//    * Currency Helpers
//    * -----------------------------------------------------------------------------
//    * A collection of useful functions that help with currency formatting
//    *
//    * Current contents
//    * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
//    *
//    * Alternatives
//    * - Accounting.js - http://openexchangerates.github.io/accounting.js/
//    *
//    */

//   theme.Currency = (function() {
//     var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

//     function formatMoney(cents, format) {
//       if (typeof cents === 'string') {
//         cents = cents.replace('.', '');
//       }
//       var value = '';
//       var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
//       var formatString = format || moneyFormat;

//       function formatWithDelimiters(number, precision, thousands, decimal) {
//         thousands = thousands || ',';
//         decimal = decimal || '.';

//         if (isNaN(number) || number === null) {
//           return 0;
//         }

//         number = (number / 100.0).toFixed(precision);

//         var parts = number.split('.');
//         var dollarsAmount = parts[0].replace(
//           /(\d)(?=(\d\d\d)+(?!\d))/g,
//           '$1' + thousands
//         );
//         var centsAmount = parts[1] ? decimal + parts[1] : '';

//         return dollarsAmount + centsAmount;
//       }

//       switch (formatString.match(placeholderRegex)[1]) {
//         case 'amount':
//           value = formatWithDelimiters(cents, 2);
//           break;
//         case 'amount_no_decimals':
//           value = formatWithDelimiters(cents, 0);
//           break;
//         case 'amount_with_comma_separator':
//           value = formatWithDelimiters(cents, 2, '.', ',');
//           break;
//         case 'amount_no_decimals_with_comma_separator':
//           value = formatWithDelimiters(cents, 0, '.', ',');
//           break;
//         case 'amount_no_decimals_with_space_separator':
//           value = formatWithDelimiters(cents, 0, ' ');
//           break;
//         case 'amount_with_apostrophe_separator':
//           value = formatWithDelimiters(cents, 2, "'");
//           break;
//       }

//       return formatString.replace(placeholderRegex, value);
//     }

//     return {
//       formatMoney: formatMoney
//     };
//   })();

//   /**
//    * Variant Selection scripts
//    * ------------------------------------------------------------------------------
//    *
//    * Handles change events from the variant inputs in any `cart/add` forms that may
//    * exist.  Also updates the master select and triggers updates when the variants
//    * price or image changes.
//    *
//    * @namespace variants
//    */
//   class Variants {
//     constructor(options) {
//       this.$container = options.$container;
//       this.product = options.product;
//       this.singleOptionSelector = options.singleOptionSelector;
//       this.originalSelectorId = options.originalSelectorId;
//       this.enableHistoryState = options.enableHistoryState;
//       this.currentVariant = this._getVariantFromOptions();

//       $(this.singleOptionSelector, this.$container).on(
//         'change',
//         this._onSelectChange.bind(this)
//       );
//     }

//     /**
//      * Get the currently selected options from add-to-cart form. Works with all
//      * form input elements.
//      *
//      * @return {array} options - Values of currently selected variants
//      */
//     _getCurrentOptions() {
//       var currentOptions = _.map(
//         $(this.singleOptionSelector, this.$container),
//         function(element) {
//           var $element = $(element);
//           var type = $element.attr('type');
//           var currentOption = {};

//           if (type === 'radio' || type === 'checkbox') {
//             if ($element[0].checked) {
//               currentOption.value = $element.val();
//               currentOption.index = $element.data('index');

//               return currentOption;
//             } else {
//               return false;
//             }
//           } else {
//             currentOption.value = $element.val();
//             currentOption.index = $element.data('index');

//             return currentOption;
//           }
//         }
//       );

//       // remove any unchecked input values if using radio buttons or checkboxes
//       currentOptions = _.compact(currentOptions);

//       return currentOptions;
//     }

//     /**
//      * Find variant based on selected values.
//      *
//      * @param  {array} selectedValues - Values of variant inputs
//      * @return {object || undefined} found - Variant object from product.variants
//      */
//     _getVariantFromOptions() {
//       var selectedValues = this._getCurrentOptions();
//       var variants = this.product.variants;

//       var found = _.find(variants, function(variant) {
//         return selectedValues.every(function(values) {
//           return _.isEqual(variant.options[values.index - 1], values.value);
//         });
//       });
      
//       return found;
//     }

//     /**
//      * Event handler for when a variant input changes.
//      */
//     _onSelectChange() {
//       var variant = this._getVariantFromOptions();

//       this.$container.trigger({
//         type: 'variantChange',
//         variant: variant
//       });

//       if (!variant) {
//         return;
//       }

//       this._updateMasterSelect(variant);
//       // this._updateImages(variant);
//       this._updatePrice(variant);
//       this._updateSKU(variant);
//       this.currentVariant = variant;

//       if (this.enableHistoryState) {
//         this._updateHistoryState(variant);
//       }

//       //console.log('variant change ' + variant.id);
//       $('button[name=add]').attr('data-add-id',variant.id);

//       // BEGIN SWATCHES
//       if (variant) {
//         var form = $('form.product-form');
//         for (var i=0,length=variant.options.length; i<length; i++) {
//           var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
//           if (radioButton !== 'undefined' && radioButton.length) {
//             radioButton.get(0).checked = true;
//           }
//         }
//         form.addClass('size-picked');
//         $('.size-warning').fadeOut();
//       }
//       // END SWATCHES

//       // Low stock alert
//       this._updateNotifications(variant);
//       this._updateSizeTrigger(variant);

//     }

//     _updateSizeTrigger(variant) {
//       const button = document.querySelector('#select-size-trigger');
//       const colorOption = button.getAttribute('data-color-option');
//       if (!button || !variant) return;
      
//       const variantTitle = variant.title.toString();
//       const spanText = (colorOption !== '') ? variantTitle.replace(colorOption, '/').replace('/ /', '') : variantTitle;
//       const span = button.querySelector('.variant-title');
//       if (!span) return;

//       span.textContent = spanText;
//     }

//     _updateNotifications(variant) {
//       if (!variant) return;

//       const cosProductSingle = document.querySelector('cos-product-single');
//       if (cosProductSingle) cosProductSingle.dispatchEvent(new CustomEvent('variant.change', { detail: { index: 3, variant } }));
      
//       // document.querySelectorAll('.preform-notifications').forEach((preformNotifiations) => {
//       //   const isLimited = preformNotifiations.getAttribute('is-limited');
//       //   let lowStockEl = preformNotifiations.querySelector('.low-stock');
  
//       //   if (!lowStockEl) {
//       //     lowStockEl = document.createElement('p');
//       //     lowStockEl.classList.add('low-stock', 'error');
//       //     preformNotifiations.appendChild(lowStockEl);
//       //   }
  
//       //   // if (isLimited) {
//       //   //   if (variant.inventory_quantity > 0) {
//       //   //     // lowStockEl.innerHTML = `Limited Edition: ${pluralize(variant.inventory_quantity, 'item')} left!`;
//       //   //     lowStockEl.innerHTML = `<span>Only</span> ${variant.inventory_quantity} <span>items left in size</span> ${variant.option2}!`;
//       //   //     $(lowStockEl).fadeIn();
//       //   //   } else {
//       //   //     // lowStockEl.innerHTML = `Limited Edition: All ${isLimited} items are sold out!`;
//       //   //     $(lowStockEl).fadeOut();
//       //   //   }
  
//       //   // } else 
//       //   if (variant.inventory_quantity > 0) {
//       //     if (variant.inventory_quantity < 5) {
//       //       lowStockEl.innerHTML = `<span>Only</span> ${variant.inventory_quantity} <span>item${(variant.inventory_quantity === 1) ? '' : 's'} left in size</span> ${variant.option2}!`;
//       //       $(lowStockEl).fadeIn();
  
//       //     } else if (variant.inventory_quantity < 15) {
//       //       lowStockEl.innerHTML = `<span>Last items left in size</span> ${variant.option2}!`;
//       //       $(lowStockEl).fadeIn();
  
//       //     } else {
//       //       $(lowStockEl).fadeOut();
//       //     }
//       //   } else {
//       //     $(lowStockEl).fadeOut();
  
//       //   }
//       // });
//     }

//     /**
//      * Trigger event when variant image changes
//      *
//      * @param  {object} variant - Currently selected variant
//      * @return {event}  variantImageChange
//      */
//     // _updateImages(variant) {
//     //   var variantImage = variant.featured_image || {};
//     //   var currentVariantImage = this.currentVariant.featured_image || {};

//     //   if (
//     //     !variant.featured_image ||
//     //     variantImage.src === currentVariantImage.src
//     //   ) {
//     //     return;
//     //   }

//     //   this.$container.trigger({
//     //     type: 'variantImageChange',
//     //     variant: variant
//     //   });
//     // }

//     /**
//      * Trigger event when variant price changes.
//      *
//      * @param  {object} variant - Currently selected variant
//      * @return {event} variantPriceChange
//      */
//     _updatePrice(variant) {
//       if (
//         variant.price === this.currentVariant.price &&
//         variant.compare_at_price === this.currentVariant.compare_at_price
//       ) {
//         return;
//       }

//       this.$container.trigger({
//         type: 'variantPriceChange',
//         variant: variant
//       });
//     }

//     /**
//      * Trigger event when variant sku changes.
//      *
//      * @param  {object} variant - Currently selected variant
//      * @return {event} variantSKUChange
//      */
//     _updateSKU(variant) {
//       if (variant.sku === this.currentVariant.sku) {
//         return;
//       }

//       this.$container.trigger({
//         type: 'variantSKUChange',
//         variant: variant
//       });
//     }

//     /**
//      * Update history state for product deeplinking
//      *
//      * @param  {variant} variant - Currently selected variant
//      * @return {k}         [description]
//      */
//     _updateHistoryState(variant) {
//       if (!history.replaceState || !variant) {
//         return;
//       }

//       var newurl =
//         window.location.protocol +
//         '//' +
//         window.location.host +
//         window.location.pathname +
//         '?variant=' +
//         variant.id;
//       window.history.replaceState({ path: newurl }, '', newurl);
//     }

//     /**
//      * Update hidden master select of variant change
//      *
//      * @param  {variant} variant - Currently selected variant
//      */
//     _updateMasterSelect(variant) {
//       $(this.originalSelectorId, this.$container).val(variant.id);
//     }
//   }

//   class Product {
//     constructor(container) {
//       this.container = container;
//       this.$container = $(container);
//       var sectionId = this.$container.attr('data-section-id');
//       this.ajaxEnabled = this.$container.data('ajax-enabled');

//       this.settings = {
//         // Breakpoints from src/stylesheets/global/variables.scss.liquid
//         mediaQueryMediumUp: 'screen and (min-width: 750px)',
//         mediaQuerySmall: 'screen and (max-width: 749px)',
//         bpSmall: false,
//         enableHistoryState: this.$container.data('enable-history-state') || false,
//         namespace: '.slideshow-' + sectionId,
//         sectionId: sectionId,
//         sliderActive: false,
//         zoomEnabled: false
//       };

//       this.selectors = {
//         addToCart: '[data-add-to-cart]',
//         addToCartText: '[data-add-to-cart-text]',
//         cartCount: '[data-cart-count]',
//         cartCountBubble: '[data-cart-count-bubble]',
//         cartPopup: '[data-cart-popup]',
//         cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
//         cartPopupClose: '[data-cart-popup-close]',
//         cartPopupDismiss: '[data-cart-popup-dismiss]',
//         cartPopupImage: '[data-cart-popup-image]',
//         cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
//         cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
//         cartPopupPlaceholderSize: '[data-placeholder-size]',
//         cartPopupProductDetails: '[data-cart-popup-product-details]',
//         cartPopupQuantity: '[data-cart-popup-quantity]',
//         cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
//         cartPopupTitle: '[data-cart-popup-title]',
//         cartPopupWrapper: '[data-cart-popup-wrapper]',
//         loader: '[data-loader]',
//         loaderStatus: '[data-loader-status]',
//         quantity: '[data-quantity-input]',
//         SKU: '.variant-sku',
//         productStatus: '[data-product-status]',
//         originalSelectorId: '#ProductSelect-' + sectionId,
//         productForm: '[data-product-form]',
//         errorMessage: '[data-error-message]',
//         errorMessageWrapper: '[data-error-message-wrapper]',
//         productImageWraps: '.product-single__photo',
//         productThumbImages: '.product-single__thumbnail--' + sectionId,
//         productThumbs: '.product-single__thumbnails-' + sectionId,
//         productThumbListItem: '.product-single__thumbnails-item',
//         productFeaturedImage: '.product-featured-img',
//         productThumbsWrapper: '.thumbnails-wrapper',
//         saleLabel: '.product-price__sale-label-' + sectionId,
//         singleOptionSelector: '.single-option-selector-' + sectionId,
//         shopifyPaymentButton: '.shopify-payment-button',
//         priceContainer: '[data-price]',
//         regularPrice: '[data-regular-price]',
//         salePrice: '[data-sale-price]',
//         unitPrice: '[data-unit-price]',
//         unitPriceBaseUnit: '[data-unit-price-base-unit]',
//         productPolicies: '[data-product-policies]'
//       };

//       this.classes = {
//         cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
//         hidden: 'hide',
//         visibilityHidden: 'visibility-hidden',
//         inputError: 'input--error',
//         productOnSale: 'price--on-sale',
//         productUnitAvailable: 'price--unit-available',
//         productUnavailable: 'price--unavailable',
//         productSoldOut: 'price--sold-out',
//         cartImage: 'cart-popup-item__image',
//         productFormErrorMessageWrapperHidden:
//           'product-form__error-message-wrapper--hidden',
//         activeClass: 'active-thumb'
//       };

//       this.$quantityInput = $(this.selectors.quantity, this.$container);
//       this.$errorMessageWrapper = $(
//         this.selectors.errorMessageWrapper,
//         this.$container
//       );
//       this.$addToCart = $(this.selectors.addToCart, this.$container);
//       this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
//       this.$shopifyPaymentButton = $(
//         this.selectors.shopifyPaymentButton,
//         this.$container
//       );
//       this.$productPolicies = $(this.selectors.productPolicies, this.$container);

//       this.$loader = $(this.selectors.loader, this.$addToCart);
//       this.$loaderStatus = $(this.selectors.loaderStatus, this.$container);

//       // Stop parsing if we don't have the product json script tag when loading
//       // section in the Theme Editor
//       if (!$('#ProductJson-' + sectionId).html()) {
//         return;
//       }

//       this.productSingleObject = JSON.parse(
//         document.getElementById('ProductJson-' + sectionId).innerHTML
//       );

//       this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
//         'js-zoom-enabled'
//       );

//       // this._initBreakpoints();
//       this._stringOverrides();
//       this._initVariants();
//       // this._initImageSwitch();
//       this._initAddToCart();
//       // this._setActiveThumbnail();
//     }

//     _stringOverrides() {
//       theme.productStrings = theme.productStrings || {};
//       $.extend(theme.strings, theme.productStrings);
//     }

//     // _initBreakpoints() {
//     //   var self = this;

//     //   enquire.register(this.settings.mediaQuerySmall, {
//     //     match: function() {
//     //       // initialize thumbnail slider on mobile if more than three thumbnails
//     //       if ($(self.selectors.productThumbImages).length > 3) {
//     //         self._initThumbnailSlider();
//     //       }

//     //       // destroy image zooming if enabled
//     //       if (self.settings.zoomEnabled) {
//     //         $(self.selectors.productImageWraps).each(function() {
//     //           _destroyZoom(this);
//     //         });
//     //       }

//     //       self.settings.bpSmall = true;
//     //     },
//     //     unmatch: function() {
//     //       if (self.settings.sliderActive) {
//     //         self._destroyThumbnailSlider();
//     //       }

//     //       self.settings.bpSmall = false;
//     //     }
//     //   });

//     //   enquire.register(this.settings.mediaQueryMediumUp, {
//     //     match: function() {
//     //       if (self.settings.zoomEnabled) {
//     //         $(self.selectors.productImageWraps).each(function() {
//     //           _enableZoom(this);
//     //         });
//     //       }
//     //     }
//     //   });
//     // }

//     _initVariants() {
//       var options = {
//         $container: this.$container,
//         enableHistoryState:
//           this.$container.data('enable-history-state') || false,
//         singleOptionSelector: this.selectors.singleOptionSelector,
//         originalSelectorId: this.selectors.originalSelectorId,
//         product: this.productSingleObject
//       };

//       this.variants = new Variants(options);

//       this.$container.on(
//         'variantChange' + this.settings.namespace,
//         this._updateAvailability.bind(this)
//       );
//       // this.$container.on(
//       //   'variantImageChange' + this.settings.namespace,
//       //   this._updateImages.bind(this)
//       // );
//       this.$container.on(
//         'variantPriceChange' + this.settings.namespace,
//         this._updatePrice.bind(this)
//       );
//       this.$container.on(
//         'variantSKUChange' + this.settings.namespace,
//         this._updateSKU.bind(this)
//       );

//     }

//     // _initImageSwitch() {
//     //   if (!$(this.selectors.productThumbImages).length) {
//     //     return;
//     //   }

//     //   var self = this;

//     //   $(this.selectors.productThumbImages)
//     //     .on('click', function(evt) {
//     //       evt.preventDefault();
//     //       var $el = $(this);

//     //       var imageId = $el.data('thumbnail-id');

//     //       self._switchImage(imageId);
//     //       self._setActiveThumbnail(imageId);
//     //     })
//     //     .on('keyup', self._handleImageFocus.bind(self));
//     // }

//     // _initAddToCart() {
//     //   $(this.selectors.productForm, this.$container).on(
//     //     'submit',
//     //     function(evt) {
//     //       if (this.$addToCart.is('[aria-disabled]')) {
//     //         evt.preventDefault();
//     //         return;
//     //       }

//     //       if (!this.ajaxEnabled) return;

//     //       evt.preventDefault();

//     //       this.$previouslyFocusedElement = $(':focus');

//     //       var isInvalidQuantity = this.$quantityInput.val() <= 0;

//     //       if (isInvalidQuantity) {
//     //         this._showErrorMessage(theme.strings.quantityMinimumMessage);
//     //         return;
//     //       }

//     //       if (!isInvalidQuantity && this.ajaxEnabled) {
//     //         // disable the addToCart and dynamic checkout button while
//     //         // request/cart popup is loading and handle loading state
//     //         this._handleButtonLoadingState(true);
//     //         var $data = $(this.selectors.productForm, this.$container);
//     //         this._addItemToCart($data);
//     //         return;
//     //       }
//     //     }.bind(this)
//     //   );
//     // }

//     // _addItemToCart(data) {
//     //   var params = {
//     //     url: '/cart/add.js',
//     //     data: $(data).serialize(),
//     //     dataType: 'json'
//     //   };

//     //   $.post(params)
//     //     .done(
//     //       function(item) {
//     //         this._hideErrorMessage();
//     //         this._setupCartPopup(item);
//     //       }.bind(this)
//     //     )
//     //     .fail(
//     //       function(response) {
//     //         this.$previouslyFocusedElement.focus();
//     //         var errorMessage = response.responseJSON
//     //           ? response.responseJSON.description
//     //           : theme.strings.cartError;
//     //         this._showErrorMessage(errorMessage);
//     //         this._handleButtonLoadingState(false);
//     //       }.bind(this)
//     //     );
//     // }

//     _initAddToCart() {
//       document.addEventListener('cart.requestStarted', () => {
//         this._handleButtonLoadingState(true);
//       });
//       document.addEventListener('cart.requestComplete', () => {
//         this._handleButtonLoadingState(false);
//       });
//     }

//     _handleButtonLoadingState(isLoading) {
//       if (isLoading) {
//         this.$addToCart.attr('aria-disabled', true);
//         this.$addToCartText.addClass(this.classes.hidden);
//         this.$loader.removeClass(this.classes.hidden);
//         this.$shopifyPaymentButton.attr('disabled', true);
//         this.$loaderStatus.attr('aria-hidden', false);
//       } else {
//         this.$addToCart.removeAttr('aria-disabled');
//         this.$addToCartText.removeClass(this.classes.hidden);
//         this.$loader.addClass(this.classes.hidden);
//         this.$shopifyPaymentButton.removeAttr('disabled');
//         this.$loaderStatus.attr('aria-hidden', true);
//       }
//     }

//     // _showErrorMessage(errorMessage) {
//     //   $(this.selectors.errorMessage, this.$container).html(errorMessage);

//     //   if (this.$quantityInput.length !== 0) {
//     //     this.$quantityInput.addClass(this.classes.inputError);
//     //   }

//     //   this.$errorMessageWrapper
//     //     .removeClass(this.classes.productFormErrorMessageWrapperHidden)
//     //     .attr('aria-hidden', true)
//     //     .removeAttr('aria-hidden');
//     // }

//     _hideErrorMessage() {
//       this.$errorMessageWrapper.addClass(
//         this.classes.productFormErrorMessageWrapperHidden
//       );

//       if (this.$quantityInput.length !== 0) {
//         this.$quantityInput.removeClass(this.classes.inputError);
//       }
//     }

//     // _setupCartPopup(item) {
//     //   this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
//     //   this.$cartPopupWrapper =
//     //     this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
//     //   this.$cartPopupTitle =
//     //     this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
//     //   this.$cartPopupQuantity =
//     //     this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
//     //   this.$cartPopupQuantityLabel =
//     //     this.$cartPopupQuantityLabel ||
//     //     $(this.selectors.cartPopupQuantityLabel);
//     //   this.$cartPopupClose =
//     //     this.$cartPopupClose || $(this.selectors.cartPopupClose);
//     //   this.$cartPopupDismiss =
//     //     this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
//     //   this.$cartPopupImagePlaceholder =
//     //     this.$cartPopupImagePlaceholder ||
//     //     $(this.selectors.cartPopupImagePlaceholder);

//     //   this._setupCartPopupEventListeners();

//     //   this._updateCartPopupContent(item);
//     // }

//     // _updateCartPopupContent(item) {
//     //   var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

//     //   this.$cartPopupTitle.text(item.product_title);
//     //   this.$cartPopupQuantity.text(quantity);
//     //   this.$cartPopupQuantityLabel.text(
//     //     theme.strings.quantityLabel.replace('[count]', quantity)
//     //   );

//     //   this._setCartPopupPlaceholder(
//     //     item.featured_image.url,
//     //     item.featured_image.aspect_ratio
//     //   );
//     //   this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
//     //   this._setCartPopupProductDetails(
//     //     item.product_has_only_default_variant,
//     //     item.options_with_values,
//     //     item.properties
//     //   );

//     //   $.getJSON('/cart.js').then(
//     //     function(cart) {
//     //       this._setCartQuantity(cart.item_count);
//     //       this._setCartCountBubble(cart.item_count);
//     //       this._showCartPopup();
//     //     }.bind(this)
//     //   );
//     // }

//     // _setupCartPopupEventListeners() {
//     //   this.$cartPopupWrapper.on(
//     //     'keyup',
//     //     function(event) {
//     //       if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
//     //         this._hideCartPopup(event);
//     //       }
//     //     }.bind(this)
//     //   );

//     //   this.$cartPopupClose.on('click', this._hideCartPopup.bind(this));
//     //   this.$cartPopupDismiss.on('click', this._hideCartPopup.bind(this));
//     //   $('body').on('click', this._onBodyClick.bind(this));
//     // }

//     // _setCartPopupPlaceholder(imageUrl, imageAspectRatio) {
//     //   this.$cartPopupImageWrapper =
//     //     this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

//     //   if (imageUrl === null) {
//     //     this.$cartPopupImageWrapper.addClass(this.classes.hidden);
//     //     return;
//     //   }

//     //   var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
//     //   var maxWidth = 95 * imageAspectRatio;
//     //   var heightRatio = 100 / imageAspectRatio;

//     //   this.$cartPopupImagePlaceholder.css('max-width', maxWidth);

//     //   $placeholder.css('padding-top', heightRatio + '%');
//     // }

//     // _setCartPopupImage(imageUrl, imageAlt) {
//     //   if (imageUrl === null) return;

//     //   this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
//     //   var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
//     //   var image = document.createElement('img');
//     //   image.src = sizedImageUrl;
//     //   image.alt = imageAlt;
//     //   image.classList.add(this.classes.cartImage);
//     //   image.dataset.cartPopupImage = '';

//     //   image.onload = function() {
//     //     this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
//     //     this.$cartPopupImageWrapper.append(image);
//     //   }.bind(this);
//     // }

//     // _setCartPopupProductDetails(
//     //   product_has_only_default_variant,
//     //   options,
//     //   properties
//     // ) {
//     //   this.$cartPopupProductDetails =
//     //     this.$cartPopupProductDetails ||
//     //     $(this.selectors.cartPopupProductDetails);
//     //   var variantPropertiesHTML = '';

//     //   if (!product_has_only_default_variant) {
//     //     variantPropertiesHTML =
//     //       variantPropertiesHTML + this._getVariantOptionList(options);
//     //   }

//     //   if (properties !== null && Object.keys(properties).length !== 0) {
//     //     variantPropertiesHTML =
//     //       variantPropertiesHTML + this._getPropertyList(properties);
//     //   }

//     //   if (variantPropertiesHTML.length === 0) {
//     //     this.$cartPopupProductDetails.html('');
//     //     this.$cartPopupProductDetails.attr('hidden', '');
//     //   } else {
//     //     this.$cartPopupProductDetails.html(variantPropertiesHTML);
//     //     this.$cartPopupProductDetails.removeAttr('hidden');
//     //   }
//     // }

//     // _getVariantOptionList(variantOptions) {
//     //   var variantOptionListHTML = '';

//     //   variantOptions.forEach(function(variantOption) {
//     //     variantOptionListHTML =
//     //       variantOptionListHTML +
//     //       '<li class="product-details__item product-details__item--variant-option">' +
//     //       variantOption.name +
//     //       ': ' +
//     //       variantOption.value +
//     //       '</li>';
//     //   });

//     //   return variantOptionListHTML;
//     // }

//     // _getPropertyList(properties) {
//     //   var propertyListHTML = '';
//     //   var propertiesArray = Object.entries(properties);

//     //   propertiesArray.forEach(function(property) {
//     //     // Line item properties prefixed with an underscore are not to be displayed
//     //     if (property[0].charAt(0) === '_') return;

//     //     // if the property value has a length of 0 (empty), don't display it
//     //     if (property[1].length === 0) return;

//     //     propertyListHTML =
//     //       propertyListHTML +
//     //       '<li class="product-details__item product-details__item--property">' +
//     //       '<span class="product-details__property-label">' +
//     //       property[0] +
//     //       ': </span>' +
//     //       property[1];
//     //     ': ' + '</li>';
//     //   });

//     //   return propertyListHTML;
//     // }

//     // _setCartQuantity(quantity) {
//     //   this.$cartPopupCartQuantity =
//     //     this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
//     //   var ariaLabel;

//     //   if (quantity === 1) {
//     //     ariaLabel = theme.strings.oneCartCount;
//     //   } else if (quantity > 1) {
//     //     ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
//     //   }

//     //   this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
//     // }

//     // _setCartCountBubble(quantity) {
//     //   this.$cartCountBubble =
//     //     this.$cartCountBubble || $(this.selectors.cartCountBubble);
//     //   this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

//     //   this.$cartCountBubble.removeClass(this.classes.hidden);
//     //   this.$cartCount.text(quantity);
//     // }

//     // _showCartPopup() {
//     //   this.$cartPopupWrapper
//     //     .prepareTransition()
//     //     .removeClass(this.classes.cartPopupWrapperHidden);
//     //   this._handleButtonLoadingState(false);

//     //   slate.a11y.trapFocus({
//     //     $container: this.$cartPopupWrapper,
//     //     $elementToFocus: this.$cartPopup,
//     //     namespace: 'cartPopupFocus'
//     //   });
//     // }

//     // _hideCartPopup(event) {
//     //   var setFocus = event.detail === 0 ? true : false;
//     //   this.$cartPopupWrapper
//     //     .prepareTransition()
//     //     .addClass(this.classes.cartPopupWrapperHidden);

//     //   $(this.selectors.cartPopupImage).remove();
//     //   this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

//     //   slate.a11y.removeTrapFocus({
//     //     $container: this.$cartPopupWrapper,
//     //     namespace: 'cartPopupFocus'
//     //   });

//     //   if (setFocus) this.$previouslyFocusedElement[0].focus();

//     //   this.$cartPopupWrapper.off('keyup');
//     //   this.$cartPopupClose.off('click');
//     //   this.$cartPopupDismiss.off('click');
//     //   $('body').off('click');
//     // }

//     // _onBodyClick(event) {
//     //   var $target = $(event.target);

//     //   if (
//     //     $target[0] !== this.$cartPopupWrapper[0] &&
//     //     !$target.parents(this.selectors.cartPopup).length
//     //   ) {
//     //     this._hideCartPopup(event);
//     //   }
//     // }

//     // _setActiveThumbnail(imageId) {
//     //   // If there is no element passed, find it by the current product image
//     //   if (typeof imageId === 'undefined') {
//     //     imageId = $(
//     //       this.selectors.productImageWraps + ':not(.hide)',
//     //       this.$container
//     //     ).data('image-id');
//     //   }

//     //   var $thumbnailWrappers = $(
//     //     this.selectors.productThumbListItem + ':not(.slick-cloned)',
//     //     this.$container
//     //   );

//     //   var $activeThumbnail = $thumbnailWrappers.find(
//     //     this.selectors.productThumbImages +
//     //       "[data-thumbnail-id='" +
//     //       imageId +
//     //       "']"
//     //   );

//     //   $(this.selectors.productThumbImages)
//     //     .removeClass(this.classes.activeClass)
//     //     .removeAttr('aria-current');

//     //   $activeThumbnail.addClass(this.classes.activeClass);
//     //   $activeThumbnail.attr('aria-current', true);

//     //   if (!$thumbnailWrappers.hasClass('slick-slide')) {
//     //     return;
//     //   }

//     //   var slideIndex = $activeThumbnail.parent().data('slick-index');

//     //   $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
//     // }

//     // _switchImage(imageId) {
//     //   var $newImage = $(
//     //     this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
//     //     this.$container
//     //   );
//     //   var $otherImages = $(
//     //     this.selectors.productImageWraps +
//     //       ":not([data-image-id='" +
//     //       imageId +
//     //       "'])",
//     //     this.$container
//     //   );

//     //   $newImage.removeClass(this.classes.hidden);
//     //   $otherImages.addClass(this.classes.hidden);
//     // }

//     // _handleImageFocus(evt) {
//     //   if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

//     //   $(this.selectors.productFeaturedImage + ':visible').focus();
//     // }

//     // _initThumbnailSlider() {
//     //   var options = {
//     //     slidesToShow: 4,
//     //     slidesToScroll: 3,
//     //     infinite: false,
//     //     prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
//     //     nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
//     //     responsive: [
//     //       {
//     //         breakpoint: 321,
//     //         settings: {
//     //           slidesToShow: 3
//     //         }
//     //       }
//     //     ]
//     //   };

//     //   $(this.selectors.productThumbs).slick(options);

//     //   // Accessibility concerns not yet fixed in Slick Slider
//     //   $(this.selectors.productThumbsWrapper, this.$container)
//     //     .find('.slick-list')
//     //     .removeAttr('aria-live');
//     //   $(this.selectors.productThumbsWrapper, this.$container)
//     //     .find('.slick-disabled')
//     //     .removeAttr('aria-disabled');

//     //   this.settings.sliderActive = true;
//     // }

//     // _destroyThumbnailSlider() {
//     //   $(this.selectors.productThumbs).slick('unslick');
//     //   this.settings.sliderActive = false;

//     //   // Accessibility concerns not yet fixed in Slick Slider
//     //   $(this.selectors.productThumbsWrapper, this.$container)
//     //     .find('[tabindex="-1"]')
//     //     .removeAttr('tabindex');
//     // }

//     _liveRegionText(variant) {
//       // Dummy content for live region
//       var liveRegionText =
//         '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

//       if (!variant) {
//         liveRegionText = theme.strings.unavailable;
//         return liveRegionText;
//       }

//       // Update availability
//       var availability = variant.available ? '' : theme.strings.soldOut + ',';
//       liveRegionText = liveRegionText.replace('[Availability]', availability);

//       // Update pricing information
//       var regularLabel = '';
//       var regularPrice = theme.Currency.formatMoney(
//         variant.price,
//         theme.moneyFormat
//       );
//       var saleLabel = '';
//       var salePrice = '';
//       var unitLabel = '';
//       var unitPrice = '';

//       if (variant.compare_at_price > variant.price) {
//         regularLabel = theme.strings.regularPrice;
//         regularPrice =
//           theme.Currency.formatMoney(
//             variant.compare_at_price,
//             theme.moneyFormat
//           ) + ',';
//         saleLabel = theme.strings.sale;
//         salePrice = theme.Currency.formatMoney(
//           variant.price,
//           theme.moneyFormat
//         );
//       }

//       if (variant.unit_price) {
//         unitLabel = theme.strings.unitPrice;
//         unitPrice =
//           theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
//           ' ' +
//           theme.strings.unitPriceSeparator +
//           ' ' +
//           this._getBaseUnit(variant);
//       }

//       liveRegionText = liveRegionText
//         .replace('[Regular]', regularLabel)
//         .replace('[$$]', regularPrice)
//         .replace('[Sale]', saleLabel)
//         .replace('[$]', salePrice)
//         .replace('[UnitPrice]', unitLabel)
//         .replace('[$$$]', unitPrice)
//         .trim();

//       return liveRegionText;
//     }

//     _updateLiveRegion(evt) {
//       var variant = evt.variant;
//       var liveRegion = this.container.querySelector(
//         this.selectors.productStatus
//       );
//       liveRegion.innerHTML = this._liveRegionText(variant);
//       liveRegion.setAttribute('aria-hidden', false);

//       // hide content from accessibility tree after announcement
//       setTimeout(function() {
//         liveRegion.setAttribute('aria-hidden', true);
//       }, 1000);
//     }

//     _updateAddToCart(evt) {
//       var variant = evt.variant;

//       if (variant) {
//         if (variant.available) {
//           this.$addToCart
//             .removeAttr('aria-disabled')
//             .attr('aria-label', theme.strings.addToCart)
//             .removeClass('buy-disabled');
//           $(this.selectors.addToCartText, this.$container).text(
//             theme.strings.addToCart
//           );
//           this.$shopifyPaymentButton.show();
//         } else {
//           // The variant doesn't exist, disable submit button and change the text.
//           // This may be an error or notice that a specific variant is not available.
//           this.$addToCart
//             .attr('aria-disabled', true)
//             .attr('aria-label', theme.strings.soldOut)
//             .addClass('buy-disabled');
//           $(this.selectors.addToCartText, this.$container).text(
//             theme.strings.soldOut
//           );
//           this.$shopifyPaymentButton.hide();
//         }
//       } else {
//         this.$addToCart
//           .attr('aria-disabled', true)
//           .attr('aria-label', theme.strings.unavailable);
//         $(this.selectors.addToCartText, this.$container).text(
//           theme.strings.unavailable
//         );
//         this.$shopifyPaymentButton.hide();
//       }
//     }

//     _updateAvailability(evt) {
//       // remove error message if one is showing
//       this._hideErrorMessage();

//       // update form submit
//       this._updateAddToCart(evt);
//       // update live region
//       this._updateLiveRegion(evt);

//       this._updatePrice(evt);
//     }

//     // _updateImages(evt) {
//     //   var variant = evt.variant;
//     //   var imageId = variant.featured_image.id;

//     //   this._switchImage(imageId);
//     //   this._setActiveThumbnail(imageId);
//     // }

//     _updatePrice(evt) {
//       var variant = evt.variant;

//       var $priceContainer = $(this.selectors.priceContainer, this.$container);
//       var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
//       var $salePrice = $(this.selectors.salePrice, $priceContainer);
//       var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
//       var $unitPriceBaseUnit = $(
//         this.selectors.unitPriceBaseUnit,
//         $priceContainer
//       );

//       // Reset product price state
//       $priceContainer
//         .removeClass(this.classes.productUnavailable)
//         .removeClass(this.classes.productOnSale)
//         .removeClass(this.classes.productUnitAvailable)
//         .removeClass(this.classes.productSoldOut)
//         .removeAttr('aria-hidden');

//       this.$productPolicies.removeClass(this.classes.visibilityHidden);

//       // Unavailable
//       if (!variant) {
//         $priceContainer
//           .addClass(this.classes.productUnavailable)
//           .attr('aria-hidden', true);

//         this.$productPolicies.addClass(this.classes.visibilityHidden);
//         return;
//       }

//       // Sold out
//       const productForm = document.querySelector(this.selectors.productForm);
//       if (productForm) {
//         const addToCartBtn = productForm.querySelector('button[name=add]');
//         if (addToCartBtn) {
//           if (!variant.available) {
//             $priceContainer.addClass(this.classes.productSoldOut);
//             addToCartBtn.setAttribute('disabled', 'disabled');
//             addToCartBtn.setAttribute('aria-disabled', true);
//             addToCartBtn.setAttribute('aria-label', theme.strings.soldOut);
//             addToCartBtn.classList.add('buy-disabled');
//             return;
//           } else {
//             addToCartBtn.removeAttribute('disabled');
//             addToCartBtn.removeAttribute('aria-disabled');
//             addToCartBtn.setAttribute('aria-label', theme.strings.addToCart);
//             addToCartBtn.classList.remove('buy-disabled');
//           }
//         }
//       }

//       // On sale
//       if (variant.compare_at_price > variant.price) {
//         $regularPrice.html(
//           theme.Currency.formatMoney(
//             variant.compare_at_price,
//             theme.moneyFormat
//           )
//         );
//         $salePrice.html(
//           theme.Currency.formatMoney(variant.price, theme.moneyFormat)
//         );
//         $priceContainer.addClass(this.classes.productOnSale);
//       } else {
//         // Regular price
//         $regularPrice.html(
//           theme.Currency.formatMoney(variant.price, theme.moneyFormat)
//         );
//       }

//       // Unit price
//       if (variant.unit_price) {
//         $unitPrice.html(
//           theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
//         );
//         $unitPriceBaseUnit.html(this._getBaseUnit(variant));
//         $priceContainer.addClass(this.classes.productUnitAvailable);
//       }
//     }

//     _getBaseUnit(variant) {
//       return variant.unit_price_measurement.reference_value === 1
//         ? variant.unit_price_measurement.reference_unit
//         : variant.unit_price_measurement.reference_value +
//             variant.unit_price_measurement.reference_unit;
//     }

//     _updateSKU(evt) {
//       var variant = evt.variant;

//       // Update the sku
//       $(this.selectors.SKU).html(variant.sku);
//     }

//     // onUnload() {
//     //   this.$container.off(this.settings.namespace);
//     // }
//   }

//   // function _enableZoom(el) {
//   //   var zoomUrl = $(el).data('zoom');
//   //   $(el).zoom({
//   //     url: zoomUrl
//   //   });
//   // }

//   // function _destroyZoom(el) {
//   //   $(el).trigger('zoom.destroy');
//   // }

//   // addEventListener('DOMContentLoaded', () => {
//   //   const container = document.querySelector('[data-section-type="product"]');
//   //   if (!container) return;

//   //   new Product(container);
//   // });
// })();
//   //Mobile sizes trigger
//   const selectSizeTrigger = document.querySelector('#select-size-trigger');
//   if (!selectSizeTrigger) return;

//   const swatchWrapper = document.querySelector('.product-single__info .swatch-wrapper');
//   if (!swatchWrapper) return;

//   const hasMultipleOptions = !swatchWrapper.classList.contains('hide-option-names');
//   let clicksGived = 0;

//   selectSizeTrigger.addEventListener('click', (e) => {
//     e.preventDefault();

//     if (swatchWrapper.classList.contains('active')) {
//       swatchWrapper.classList.remove('active');
//       selectSizeTrigger.classList.remove('active');
//       clicksGived = 0;

//     } else {
//       swatchWrapper.classList.add('active');
//       selectSizeTrigger.classList.add('active');

//       document.addEventListener('scroll', (e) => {
//         setTimeout(() => {
//           swatchWrapper.classList.remove('active');
//           selectSizeTrigger.classList.remove('active');
//           clicksGived = 0;

//         }, 1000)
//       }, { once: true });
//     }
//   });

//   swatchWrapper.addEventListener('click', (e) => {
//     clicksGived++;

//     if (hasMultipleOptions) {
//       if (clicksGived === 2) {
//         swatchWrapper.classList.remove('active');
//         selectSizeTrigger.classList.remove('active');
//         clicksGived = 0;
//       }
//     } else {
//       swatchWrapper.classList.remove('active');
//       selectSizeTrigger.classList.remove('active');
//       clicksGived = 0;
//     }
//   });
// })();

class CosProductSingle extends HTMLElement {
  constructor() {
    super();
    this.listeners = new Listeners();
    this.hideListeners = new Listeners();
    this.sizesActive = false;
  }
  
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.addToCartButton = this.form.querySelector('button[name=add]');
    if (!this.addToCartButton) return;

    this.isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (this.isMobile) {      
      this.sizeNotSelected = true;
    }

    // this.handleAddToCart();
    // this.handleSizeTrigger();
    // this.handleSwatches();
    this.handleScrollToImage();
    this.initAddToCart();
    this.initPhotoswipe();
  }

  disconnectedCallback() {
    this.listeners.removeAll();
    this.hideListeners.removeAll();
  }

  handleSizeTrigger() {
    this.sizeTrigger = this.querySelector('#select-size-trigger');
    if (!this.sizeTrigger) return;

    this.listeners.add(this.sizeTrigger, 'click', (e) => {
      this.onSizeTriggerClick();
    });    
  }

  onSizeTriggerClick(e) {
    const selectSizePopup = document.querySelector('#selectSizePopup');
    if (!selectSizePopup) return;

    selectSizePopup.togglePopup(e);

    // if (this.sizesActive) {
    //   this.hideSizes();
    // } else {
    //   this.showSizes();

    //   // this.hideListeners.add(window, 'scroll', (e) => {
    //   //   setTimeout(() => {
    //   //     this.hideSizes();
    //   //   }, 1000);
    //   // });
    // }
  }

  handleScrollToImage() {
    if (this.isMobile) {
      this.listeners.add(window, 'pageshow', (event) => {
        if (event.persisted) return;

        const elToScrollTo = document.querySelector('.product-template__container');
        onSortGoTo(elToScrollTo);
      });
    }
  }

  // scrollCallback() {
    // import(window.modules.photoswipe).then(({ default: PhotoSwipeLightbox }) => {
    // });
  // }

  initPhotoswipe() {
    window.addEventListener('load', () => {
      import(window.modules.photoswipe);
    });
  }

  showSizes() {
    this.classList.add('show-sizes');
    this.sizeTrigger.classList.add('active');
    document.body.classList.add('disable-scroll__pp');

    this.overlay = document.createElement('div');
    this.overlay.classList.add('overlay', 'show');
    this.parentElement.insertBefore(this.overlay, this);

    this.hideListeners.add(this.overlay, 'click', (e) => {
      this.hideSizes();
    });

    this.sizesActive = true;

    const selectedOption = this.form.querySelector('.single-option-selector:checked');
    if (!selectedOption) return;

    this.updateSizeTrigger(selectedOption);
  }

  hideSizes() {
    this.classList.remove('show-sizes');
    this.sizeTrigger.classList.remove('active');
    document.body.classList.remove('disable-scroll__pp');
    this.overlay.remove();

    this.hideListeners.removeAll();
    this.sizesActive = false;
  }

  onVariantChange(option) {
    if (!option) return; 
    if (this.variantId === option.dataset.variantId) return;

    this.variantId = option.dataset.variantId;

    window.dispatchEvent(new CustomEvent('variant.change', {
      detail: {
        index: option.dataset.index,
        variantId: this.variantId
      }
    }));

    document.querySelectorAll(`input[data-variant-id="${this.variantId}"]:not(:checked)`).forEach((swatch) => {
      swatch.checked = true;
    });

    // this.updateSwatches(option);
    this.updateAddToCart(option);
    this.updateSizeTrigger(option);
    this.addToCartButton.setAttribute('data-add-id', this.variantId);
    this.updateHistoryState();   
  }

  updateHistoryState() {
    if (!history.replaceState) return;

    const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + this.variantId;
    window.history.replaceState({ path: newurl }, '', newurl);
  }

  // updateSwatches(option) {
  //   const swatches = this.querySelectorAll('.single-option-selector');
  //   swatches.forEach((swatch) => {
  //     if (swatch !== option) {
  //       swatch.checked = false;
  //     }
  //   });
  // }

  updateAddToCart(option) {
    if (option.dataset.available === 'true') {
      this.enableAddToCart();
    } else {
      this.disableAddToCart();
    }
  }

  updateSizeTrigger(option) {
    this.sizeNotSelected = false;
    this.sizeTrigger = this.querySelector('#select-size-trigger');
    if (!this.sizeTrigger) return;

    const colorOption = this.sizeTrigger.getAttribute('data-color-option');
    const variantTitle = option.value.toString();    
    const spanText = (colorOption !== '') ? variantTitle.replace(colorOption, '/').replace('/ /', '') : variantTitle;
    const span = this.sizeTrigger.querySelector('.variant-title');
    if (!span) return;

    span.textContent = spanText;
  }

  enableAddToCart() {
    document.querySelectorAll('button[name=add]').forEach((button) => {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.setAttribute('aria-label', window.theme.strings.addToCart);
      button.textContent = window.theme.strings.addToCart;
    });
  }

  disableAddToCart() {
    document.querySelectorAll('button[name=add]').forEach((button) => {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', true);   
      button.setAttribute('aria-label', window.theme.strings.soldOut);
      button.textContent = window.theme.strings.soldOut;
    });
  }

  initAddToCart() {
    document.addEventListener('liquid-ajax-cart:request-start', () => {
      this.handleButtonLoadingState(true);
    });
    document.addEventListener('liquid-ajax-cart:request-end', () => {
      this.handleButtonLoadingState(false);
    });
  }

  handleButtonLoadingState(isLoading) {
    if (isLoading) {
      this.addToCartButton.setAttribute('aria-disabled', true);
      // this.addToCartButton.textContent = '';
      // this.addToCartButton.insertAdjacentHTML('beforeend', '<span class="loader"></span>');
    } else {
      this.addToCartButton.removeAttribute('aria-disabled');
      // this.addToCartButton.textContent = window.theme.strings.addToCart;
      // this.addToCartButton.querySelector('.loader').remove();
    }
  }
}
if (!customElements.get('cos-product-single'))  customElements.define('cos-product-single', CosProductSingle);

class CosSwatch extends HTMLElement {
  constructor() {
    super();
    this.listeners = new Listeners();
  }

  connectedCallback() {
    const cosProductSingle = document.querySelector('cos-product-single');
    if (!cosProductSingle) return;

    this.swatches = this.querySelectorAll('.single-option-selector');
    this.swatches.forEach((option) => {
      this.listeners.add(option, 'change', () => {
        cosProductSingle.onVariantChange(option);
      });
    });

    // window.addEventListener('variant.change', (event) => {
    //   if (event.detail.cosSwatch === this) return;

    //   this.updateSwatches(event.detail.variantId);
    // });
  }

  // updateSwatches(variantId) {
    // this.swatches.forEach((swatch) => {
    //   if (swatch.dataset.variantId === variantId) {
    //     swatch.checked = true;
    //   } else {
    //     swatch.checked = false;
    //   }
    // });
  // } 
}
// check if the element is already registered
if (!customElements.get('cos-swatch')) customElements.define('cos-swatch', CosSwatch);

